import type { AssetEvent, Datapoint, Dataset, MeasurementRecord } from '../types'

// We can have really weird long numbers which could break the layout on certain screen sizes, especially if a mid is given.
export function roundNumber (number): number {
  return number.toPrecision(5)
}

export function getLineDatasets (measurements: MeasurementRecord[]): Dataset[] {
  // Group measurements into datasets by PartitionKey
  const dataGroupedByLabel: Record<string, Datapoint[]> = measurements
    .reduce((acc, m) => {
      const groupLabel = m.PartitionKey
      if (!acc[groupLabel]) acc[groupLabel] = []

      const dataPoint: Datapoint = {
        x: Number(m.distance),
        y: Number(m.value),
      }
      acc[groupLabel].push(dataPoint)
      return acc
    }, {})

  // Return array of objects with label, data, and various chart settings
  return Object.entries(dataGroupedByLabel).map(([label, data]) => ({ data, label }))
}

export function getHistogramBins (
  data: Datapoint[], binCount: number = 7
): Datapoint[] {
  const yValues = data.map(d => d.y)
  const min = Math.min(...yValues)
  const max = Math.max(...yValues)
  const binSize = (max - min) / binCount

  // Create bins
  const bins = Array.from({ length: binCount }, (_, i) => {
    const binStart = min + (i * binSize)
    const binEnd = binStart + binSize

    return {
      label: `${binStart.toFixed(2)} - ${binEnd.toFixed(2)}`,
      start: binStart,
      end: binEnd,
      count: 0
    }
  })

  // Count data points in each bin
  yValues.forEach(value => {
    const binIndex = Math.min(
      Math.floor((value - min) / binSize),
      binCount - 1
    )
    bins[binIndex].count++
  })

  return bins.map(bin => ({
    x: bin.label,
    y: bin.count
  }))
}

export function getDonutGroups (
  event: AssetEvent, partitionKey: string
): Record<string, number> {
  const results: Record<string, number> = {}

  Object.entries(event).forEach(([key, value]) => {
    if (key.startsWith(`${partitionKey}_`)) {
      const numValue = Number(value)
      if (!isNaN(numValue) && value !== null && value !== '') {
        results[key.replace(`${partitionKey}_`, '')] = numValue
      }
    }
  })

  return results
}
